export function displayName(user: {
  authorName?: string | null
  title?: string | null
  username?: string | null
  email?: string | null
}): string | null {
  return user.authorName ?? user.title ?? user.username ?? user.email ?? null
}
